// removed by extract-text-webpack-plugin
module.exports = {"EmailCapture":"EmailCapture---17AWK"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/settings/ChatWidget/components/Advanced/components/EmailCapture/style.styl
// module id = CQR/
// module chunks = 89